import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { preloadRoutes, preloadCriticalComponents } from '@/utils/performance';

// Route preloading map for common user flows
const ROUTE_PRELOAD_MAP: Record<string, Array<() => Promise<any>>> = {
  '/': [
    () => import('@/pages/QuestMap'),
  ],
  '/login': [
    () => import('@/pages/ParentDashboard'),
    () => import('@/pages/MyProgress'),
  ],
  '/signup': [
    () => import('@/pages/ParentDashboard'),
    () => import('@/pages/MyProgress'),
  ],
  '/quest-map': [
    () => import('@/pages/LessonViewer'),
    () => import('@/pages/Quiz'),
  ],
  '/saint-of-the-day': [
    () => import('@/pages/GuessTheSaint'),
  ],
  '/pilgrims-arcade': [
    () => import('@/pages/EmojiQuiz'),
    () => import('@/pages/SacramentalsMemory'),
    () => import('@/pages/SpotTheHeresy'),
    () => import('@/pages/GeographyQuest'),
    () => import('@/pages/BibleTimeline'),
    () => import('@/pages/CatholicDecoder'),
  ],
};

// Activity component preloading for lesson pages
const LESSON_ACTIVITY_COMPONENTS = [
  () => import('@/components/lesson/activities/ActivityBlocks/DefinitionMatchBlock'),
  () => import('@/components/lesson/activities/ActivityBlocks/RiddleBlock'),
  () => import('@/components/lesson/activities/ActivityBlocks/AnagramBlock'),
  () => import('@/components/lesson/activities/ActivityBlocks/TrueFalseBlock'),
];

export const useRoutePreloading = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Preload related routes based on current path
    const routesToPreload = ROUTE_PRELOAD_MAP[currentPath];
    if (routesToPreload) {
      preloadRoutes(routesToPreload);
    }

    // Preload activity components when on lesson-related pages
    if (currentPath.includes('/lesson/') || currentPath.includes('/quest-map')) {
      preloadCriticalComponents(LESSON_ACTIVITY_COMPONENTS);
    }
  }, [location.pathname]);
};

export default useRoutePreloading;